<div #avatar [attr.hasImg]="!!_img" [ngClass]="theme"></div>
